export default __webpack_public_path__ + "static/media/books.ee3eaf71.jpeg";